import { createFileRoute, Link } from "@tanstack/react-router";
import { ArrowLeft, FileDown, Files } from "lucide-react";

export const Route = createFileRoute("/education/research/templates")({
  head: () => ({
    meta: [
      { title: "Research Templates — Legal Research Hub | Nkadimeng Danny" },
      {
        name: "description",
        content:
          "Free editable RTF templates for legal research: research memorandum, heads of argument and legal opinion. Drop into Word or Google Docs.",
      },
    ],
  }),
  component: TemplatesPage,
});

const TEMPLATES = [
  {
    href: "/templates/research-memorandum.rtf",
    title: "Research Memorandum",
    body: "Issue, brief facts, applicable law, analysis (IRAC), recommendations, sources consulted.",
  },
  {
    href: "/templates/heads-of-argument.rtf",
    title: "Heads of Argument",
    body: "Court, parties, nature of proceedings, points in limine, summary of facts, legal submissions, relief sought.",
  },
  {
    href: "/templates/legal-opinion.rtf",
    title: "Legal Opinion",
    body: "Instructions, factual background, questions for opinion, law applied, opinion and conclusion.",
  },
  {
    href: "/templates/letter-of-demand.rtf",
    title: "Letter of Demand",
    body: "Formal demand letter — parties, cause of action, amount, time limit, consequences.",
  },
];

function TemplatesPage() {
  return (
    <div className="container-narrow py-10">
      <Link to="/education/research" className="inline-flex items-center gap-1 text-xs text-navy/70 hover:text-navy">
        <ArrowLeft className="h-3.5 w-3.5" /> Back to Research Hub
      </Link>
      <div className="mt-3 flex items-center gap-3">
        <span className="rounded-md bg-navy/5 p-2 text-navy"><Files className="h-5 w-5" /></span>
        <div>
          <h1 className="font-display text-3xl text-navy">Research Templates</h1>
          <p className="text-sm text-muted-foreground">Free, editable RTF — opens in Word, Google Docs and LibreOffice</p>
        </div>
      </div>

      <ul className="mt-6 grid gap-4 sm:grid-cols-2">
        {TEMPLATES.map((t) => (
          <li key={t.href} className="rounded-lg border border-input bg-card p-5">
            <h2 className="font-display text-lg text-navy">{t.title}</h2>
            <p className="mt-1 text-sm text-muted-foreground">{t.body}</p>
            <a
              href={t.href}
              download
              className="mt-3 inline-flex items-center gap-2 rounded-md bg-navy px-3 py-2 text-xs font-semibold text-navy-foreground hover:bg-navy/90"
            >
              <FileDown className="h-3.5 w-3.5" /> Download .rtf
            </a>
          </li>
        ))}
      </ul>

      <p className="mt-8 text-xs italic text-muted-foreground">
        Templates are general guides for legal-education purposes only. Adapt to the facts, jurisdiction
        and rules of court that apply to your matter. Not a substitute for legal advice.
      </p>
    </div>
  );
}
